module.exports = __webpack_public_path__ + "img/enrichment.c95f462b.png";